import '../../styles/Message/Message.css';

import { Button }                        from 'antd';
import { Col }                           from 'antd';
import Row                               from 'components/App/Row';
import { observer }                      from 'mobx-react';
import { DownloadOutlined }              from '@ant-design/icons';
import { ApiCollection }                 from 'collections/ApiCollection';
import { ROLE_STANDIST }                 from 'constants/RoleReferences';
import { appStore }                      from 'stores/AppStore';
import currentSession                    from 'utils/currentSession';
import { ROLES_CONVERTER, STAND_STATUS } from 'utils/constants';
import { toSafeMessageHtml }             from 'utils/richTextContent';
import FormattedMessageWrapper           from '../App/FormattedMessageWrapper';
import MessageModel                      from 'models/MessageModel';
import MessageMediaModel                 from 'models/MessageMediaModel';

const MessageMedias = observer(({
  message,
  messageMediaCollection,
}: {
  message: MessageModel;
  messageMediaCollection: ApiCollection<MessageMediaModel>;
}) => (
  <ul>
    {messageMediaCollection
      .filter((messageMedia: MessageMediaModel) => messageMedia.messageId === message.id)
      .map((messageMedia: MessageMediaModel) => (
        <li key={messageMedia.id}>
          <a href={messageMedia.objectUrl} rel="noreferrer" target="_blank">
            <DownloadOutlined /> <FormattedMessageWrapper id="Télécharger" /> {messageMedia.mediaFileName}
          </a>
        </li>
      ))}
  </ul>
));

const Message = ({
  additionalContent,
  editMessage,
  lastMessage,
  message,
  messageMediaCollection,
  newDemandStatus,
  newStandStatus,
}: {
  additionalContent?: any;
  editMessage?: (() => void) | null;
  lastMessage: boolean;
  message: MessageModel;
  messageMediaCollection: ApiCollection<MessageMediaModel>;
  newDemandStatus?: any;
  newStandStatus?: id;
}) => {
  const { roleCollection } = appStore;

  const messageContent = message.content ? message.content : '';

  const transformRole = (role: string) => {
    let found = null;

    if (roleCollection.models) {
      found = roleCollection.models.find(roleModel => roleModel.get('@id') === role);

      if (found) {
        return <FormattedMessageWrapper id={found.get('label').replace('Super ', '')} />;
      }
    }

    return null;
  };

  return (
    <Row
      className={`message ${currentSession.user.user_id === message.createdById ? 'me' : 'not-me'}`}
      style={{ width: '100%' }}
    >
      <Col className="message-header" span={6}>
        <div className="main">
          <small>{message.createdAtDate.format('DD/MM/YYYY HH:mm')}</small>

          {lastMessage && message.createdByRoleReference !== ROLE_STANDIST ? (
            <>
              <br />
              <b>
                <FormattedMessageWrapper id="Organisateur" />
              </b>
            </>
          ) : (
            <>
              {message.createdByFirstName && (
                <>
                  <br />
                  <b>{message.createdByFullName}</b>
                </>
              )}

              <br />

              {message.get('createdByStandRole')
                ? ROLES_CONVERTER[message.createdByStandRole]
                : transformRole(message.createdByRoleIri)}
            </>
          )}

          <br />

          {newStandStatus && <small>{STAND_STATUS[newStandStatus as number]}</small>}
          {newDemandStatus && <small>{newDemandStatus}</small>}
        </div>
      </Col>

      <Col className="message-body" span={18}>
        <div className="message-text">
          <div style={{ float: 'right', marginBottom: 10, marginLeft: 10 }}>
            {editMessage && (
              <Button htmlType="button" onClick={editMessage}>
                <FormattedMessageWrapper id="Modifier" />
              </Button>
            )}
          </div>

          <div dangerouslySetInnerHTML={{ __html: toSafeMessageHtml(messageContent) }} />
        </div>

        <div className="message-attachments">
          <MessageMedias
              message={message}
              messageMediaCollection={messageMediaCollection}
          />
        </div>

        {additionalContent && <div className="additional-content">{additionalContent}</div>}
      </Col>
    </Row>
  );
};

const MessageObserver = observer(Message);

export default MessageObserver;
